<template>
  <body class="d-flex justify-content-center align-items-center vh-100 bg-light" style="flex-direction: column;">
    <img src="../assets/logo2.png" style="cursor:pointer">
    <div class="card shadow p-4" style="width: 350px;">
      <h2 class="text-center mb-3">Login</h2>
      <form method="POST">
        <div class="mb-3">
          <label for="username" class="form-label">Username</label>
          <input v-model="username" type="text" id="username" name="username" class="form-control" required>
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input v-model="password" type="password" id="password" name="password" class="form-control" required @keydown.enter="login">
        </div>
        <p class="small mb-1 pb-lg-2"><a class="text-black-50" style="cursor:pointer" @click="router.push('resetPassword')">Password Dimenticata?</a></p>
        <button @click="login" type="button" class="btn btn-success w-100">Login</button>
      </form>
    </div>
  </body>
</template>

<script>
import { ref } from 'vue';
import loginMethods from "../api/resources/loginMethods"
import { useUserStore } from '@/stores/userStore.js';
import { storeToRefs } from 'pinia'
import router from '../router/index.js'
export default {
  name: 'loginView',
  emits: ['alert'],
  setup(_, { emit }) {
    const username = ref(null);
    const password = ref(null);

    const user = useUserStore();
    const { loggedUsername, logged } = storeToRefs(user);

    async function login() {
      logout();
      let obj = {
        username: username.value,
        password: password.value
      }
      let res = await loginMethods.login(obj);
      if (!res) {
        emit('alert', {message:"Credenziali errate!",color:"red"});
      }
      else {
        if(res == true){
          router.push("/")
          emit('alert', {message:"Accesso eseguito!",color:"green"});
        }
        else if(res == "refreshPassword"){
          router.push("/")
          emit('alert', {message:"Accesso eseguito!",color:"green"});
          alert("Ricordati di impostare la tua password in Area Agente!");
        }
      }
    }

    async function logout() {
      loginMethods.logout();
    }

    return {
      username, password,
      login, logout, loggedUsername, logged, router
    }
  }
}
</script>
